"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * returns day label in capitalize form eg: 'monday - tuesday' to 'Monday - Tuesday'
 * @param {String} dayLabel
 * @returns {String}
 */
function getCapitalizeDayLabel(dayLabel) {
  var dayLabels = dayLabel.split(' - ');
  return dayLabels.map(function (item) {
    return "".concat(item.charAt(0).toUpperCase()).concat(item.slice(1));
  }).join(' - ');
}
var _default = exports["default"] = getCapitalizeDayLabel;